import React from "react";
import {useRolesQueryQuery} from "../../generated/graphql";
import {GraphQlSelectId} from "./GraphQlSelectId";
import {GraphQlSelect} from "./GraphQlSelect";

export const RoleSelect = (props) => {
    const query = useRolesQueryQuery();
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="label" />:<GraphQlSelect queryResult={query} {...props}  labelField="name" />;
}